module.exports = __webpack_public_path__ + "img/2795712.f64a09b2.svg";